import { render, staticRenderFns } from "./forwardUpload.vue?vue&type=template&id=1f43a996&"
import script from "./forwardUpload.vue?vue&type=script&lang=js&"
export * from "./forwardUpload.vue?vue&type=script&lang=js&"
import style0 from "./forwardUpload.vue?vue&type=style&index=0&id=1f43a996&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports